import { lazy } from '@atlassian/react-loosely-lazy';
import type AttachmentsFilmstripView from './ui/filmstrip-view/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncAttachmentsFilmstripView = lazy<typeof AttachmentsFilmstripView>(() =>
	import(/* webpackChunkName: "async-jira-issue-field-attachments-filmstrip" */ './index').then(
		(module) => module.AttachmentsFilmstripView,
	),
);
